module.exports = __webpack_public_path__ + "img/neochat.6f52e50e.svg";